import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface MessageDetail {
    detail?: string;
    message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private errors = new Subject<MessageDetail[]>();

  private title: string = '';
  private autoclose: boolean = true;
  constructor() { }

  public addErrors = (title: string, errors: string[], autoclose: boolean): void => {
    this.title = title;
    this.autoclose = autoclose;
    this.errors.next(errors.map(e=><MessageDetail>{message:e}));
  }

  public addApiErrors = (title: string, errors: MessageDetail[], autoclose: boolean): void => {
    this.title = title;
    this.autoclose = autoclose;
    this.errors.next(errors);
  }

  public getErrors = () =>
    this.errors.asObservable();

  public getTitle(): string {
    return this.title;
  }

  public isAutoClose(): boolean {
    return this.autoclose;
  }
}
